import { render, staticRenderFns } from "./series_label.vue?vue&type=template&id=a09dc452"
import script from "./series_label.vue?vue&type=script&lang=js"
export * from "./series_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports